<script lang="ts">
// import axios from 'axios'

export default {
    name: 'SelectCity',
    emits: ['updateCitiesByInsee'],
    data() {
        return {
            selectedCities: '',
            loadingCity: false,
        }
    },
    mounted() {
    },
    methods: {
        setCities() {
            if (this.selectedCities) {
                this.loadingCity = true
                const data = this.selectedCities.split(',')
                this.$emit('updateCitiesByInsee', data)
                this.selectedCities = ''
                this.loadingCity = false
            }
        },
    },
}
</script>

<template>
    <div class="mb-4">
        <v-label class="mt-2" for="insee">
            Code INSEE
            <span v-html="$config.public.form_label_required_text || '*'" />
        </v-label>
        <div class="text-caption mb-2">
            Séparer chaque code INSEE par une virgule, puis cliquer sur le bouton + pour les ajouter à la sélection, ou cliquer sur les communes sur la carte.
        </div>
        <v-text-field
            id="insee"
            v-model="selectedCities"
            :loading="loadingCity"
            density="compact"
            variant="solo"
            single-line
            hide-details
        />
        <v-btn class="mt-2" variant="text" :loading="loadingCity" prepend-icon="mdi-plus" color="primary" size="small" :disabled="!selectedCities" @click="setCities()">
            Ajouter les communes
        </v-btn>
    </div>
</template>
